import styled from "styled-components";
import { baseColors } from "../../../../../themes/definitions/si/cis/base-colors";
import { MiniOrbitHeaderDefaultBox } from "./mini-orbit-header.default.box";

export const MiniOrbitHeaderSICisBox = styled(MiniOrbitHeaderDefaultBox)`
    background: ${props => props.theme.colors.backgroundContrast};
    box-shadow: 0px 0px 6px ${baseColors.base08Shadow};
`;
